<template>
<div id="container">
   <div class="locationWrap partner">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>기업협의회
       </strong>
     </div>
   </div>
   <div class="contents">
     <div class="inner">
       <div class="subTitWrap aniBox type_left gogo">
         <h2>기업협의회 가입신청</h2>
       </div>

       <div class="request">
         <iframe id="epContentViewFrame" :src="'/pencake/org/new?opt=user&reqUserId='+userId" style="width:100%" frameborder="0"></iframe>
         <!--<iframe id="epContentViewFrame" :src="'/pencake/org/new?opt=user&reqUserId='+userId" style="width:100%" frameborder="0"></iframe>-->
         <!--<iframe id="epContentViewFrame" src="/pencake/org/new?opt=user&reqUserId='userId'" style="width:100%" frameborder="0"></iframe>-->
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PartnerApply',
  data () {
    return {
    }
  },
  mounted () {
    // eslint-disable-next-line
    iFrameResize({ log: false, inPageLinks: true, heightCalculationMethod: 'bodyScroll', minHeight: 800, checkOrigin: false, autoResize: true }, '#epContentViewFrame')
  },
  computed: {
    ...mapState({
      userId: state => state.auth.userInfo.user_id
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartnerApply.vue